import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: 'hacksaw/game/list',
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      headers: {
        'X-Partner-Name': projectName,
      },
    }),
  },
  sessionUrlData: {
    url: 'hacksaw/game/launch',
    method: QueryTypes.GET,
    getQuery: params => {
      const platformValue = params.platform || 'desktop';
      const query: string[] = [];
      query.push(`game_id=${params.gameId}`);
      query.push(`platform=${platformValue}`);
      if (platformValue === 'mobile') {
        query.push(`lobbyurl=${encodeURIComponent(params.lobbyurl || 'null')}`);
      }
      query.push(`mode=${params.mode || 'live'}`);
      query.push(`language=${params.lang || 'en'}`);
      return `?${query.join('&')}`;
    },
    getHeaders: () => ({
      headers: {
        'X-Partner-Name': projectName,
        'X-Partner-Authorization': parseCookies(),
      },
    }),
    converter: converter.convertGameUrl,
  },
};
